import { HOST } from "../constants/HostConstants";

export const adminKeyHistory = async () => {
  try {
    const res = await fetch(`${HOST}/api/transaction/adminKeyHistory`, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
      },
    });
    const data = await res.json();
    if (!res.ok) return { success: false, error: data?.error || "Failed" };
    return { success: true, data: Array.isArray(data) ? data : [] };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
